import React from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontSize: "32px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.08px",
    [theme.breakpoints.down('xs')]: {
      fontSize: "24px",
    },
  },
  icon: {
    paddingRight: "24px",
    width: "50px",
  },
}));

export default function DashboardSection({
  title,
  icon,
}: {
  title: string;
  icon: string;
}) {
  const classes = useStyles();

  return (
    <Grid item style={{ display: "flex" }}>
      <img src={icon} alt={title} className={classes.icon} />
      <span className={classes.sectionTitle}>{title}</span>
    </Grid>
  );
}
